import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress TradingView widget errors from showing the React error overlay
// These are third-party widget errors that don't affect app functionality
const originalOnError = window.onerror;
window.onerror = function(message, source, lineno, colno, error) {
  // Check if it's a TradingView related error
  if (
    (typeof message === 'string' && message.includes('Script error')) ||
    (source && source.includes('tradingview'))
  ) {
    console.log('TradingView widget error suppressed:', message);
    return true; // Prevent the error from propagating
  }
  // Call original handler for other errors
  if (originalOnError) {
    return originalOnError(message, source, lineno, colno, error);
  }
  return false;
};

// Also handle unhandled promise rejections from TradingView
window.addEventListener('unhandledrejection', function(event) {
  if (
    event.reason && 
    (event.reason.toString().includes('tradingview') || 
     event.reason.toString().includes('Script error'))
  ) {
    event.preventDefault();
    console.log('TradingView promise rejection suppressed');
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
